module.exports = __webpack_public_path__ + "static/media/icon-prev-arrow.0e6e200a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-prev-arrow.svg
// module id = 681
// module chunks = 0